/**
 * 자사몰 예약 퍼널의 페이지 단위 단계.
 *
 * ERP `pre_reservation`은 **예약 시작(BOOKING_STARTED)** 이후만 남기므로,
 * 그 앞단(홈·검색·차량조회) 이탈은 프론트에서 이 이벤트로 직접 수집한다.
 * 값의 순서 = 퍼널 순서이며, {@link D2C_FUNNEL_STEP_ORDER}로 정렬 근거를 고정한다.
 *
 * 기존 Mixpanel 이벤트와 1:1 대응:
 * homepage_viewed / search_started / car_detailed_viewed /
 * booking_started / reservation_created
 * 결제 시작은 대응하는 Mixpanel 이벤트 없이 각 사이트가 따로 보낸다.
 */
export var D2CFunnelStep;
(function (D2CFunnelStep) {
    /** 세션 최초 진입(홈/랜딩 도달) */
    D2CFunnelStep["SESSION_ENTRY"] = "SESSION_ENTRY";
    /** 검색 실행 */
    D2CFunnelStep["SEARCH_STARTED"] = "SEARCH_STARTED";
    /** 차량 상세 조회 */
    D2CFunnelStep["VEHICLE_VIEWED"] = "VEHICLE_VIEWED";
    /** 예약서 작성 시작 */
    D2CFunnelStep["BOOKING_STARTED"] = "BOOKING_STARTED";
    /**
     * 결제 시작: 결제 화면에서 손님이 고객 정보를 제출하는 결제 버튼(현장 결제 사이트는
     * 예약 버튼)을 누른 순간. 확인 창·고객 정보 저장 요청·결제창보다 먼저 기록하므로,
     * "누르지 않았다"와 "눌렀는데 진행되지 않았다"를 가를 수 있다. 2026-10-30 에 네 사이트에
     * 추가했으며, 그 변경이 배포되기 전 기간에는 데이터가 없다.
     */
    D2CFunnelStep["PAYMENT_STARTED"] = "PAYMENT_STARTED";
    /** 예약 확정(사전예약 생성) */
    D2CFunnelStep["RESERVATION_CREATED"] = "RESERVATION_CREATED";
})(D2CFunnelStep || (D2CFunnelStep = {}));
/** 퍼널 순서(위 → 아래). 집계·표시 정렬의 단일 근거. */
export const D2C_FUNNEL_STEP_ORDER = [
    D2CFunnelStep.SESSION_ENTRY,
    D2CFunnelStep.SEARCH_STARTED,
    D2CFunnelStep.VEHICLE_VIEWED,
    D2CFunnelStep.BOOKING_STARTED,
    D2CFunnelStep.PAYMENT_STARTED,
    D2CFunnelStep.RESERVATION_CREATED,
];
